<template>
    <div class="crud-wrapper">
        <crud-toolbar :modalMode="modalMode" :newState="newState" :showBack="false" :title="modalTitle" print
                      @onCommand="toolbarCommand"></crud-toolbar>

        <crud-form :modal-mode="modalMode" :ref="formName" fullWidth v-model="validForm">

            <v-layout row wrap>
                <v-flex md4 xs4>
                    <v-slide-y-transition>
                        <v-card>
                            <!--<v-card-title class="subheading">Selecionar cheque para vincular recebimento</v-card-title>-->
                            <v-card-text>
                                <a-data-grid :columns="summaryCols" :data="summary"
                                             :options="summaryOptions"></a-data-grid>
                            </v-card-text>
                        </v-card>
                    </v-slide-y-transition>
                </v-flex>

                <v-flex xs8>
                    <v-layout column pa-3>
                        <v-expand-transition>
                            <v-flex column v-if="formData.closed_at">
                                <label class="title grey--text">{{formData.closed_at}}</label>
                            </v-flex>
                        </v-expand-transition>

                        <v-flex column>
                            <label class="v-label v-label--active theme--light aLabel">Loja</label>
                            <label class="title grey--text" v-if="storeId > 0">{{storeName}}</label>
                            <label class="subheading red--text" v-else>Selecione a loja acima...</label>
                        </v-flex>
                        <v-flex column>
                            <label class="v-label v-label--active theme--light aLabel">Usuário</label>
                            <label class="title font-weight-bold grey--text">{{userName}}</label>
                        </v-flex>

                        <v-flex>
                            <v-layout row wrap>
                                <a-number-field :disabled="!newState" label="Valor em Caixa agora"
                                                number-mask="us"
                                                sm4 v-model="formData.balance" validate="gtZero"></a-number-field>
                                <v-flex column sm8>
                                    <label class="v-label v-label--active theme--light aLabel"
                                           style="margin-bottom: 5px;">Diferença</label>
                                    <label :class="{'grey--text': formData.difference === 0,
                                                    'green--text': formData.difference > 0,
                                                    'red--text': formData.difference < 0}"
                                           class="title font-weight-bold">{{formData.difference | fmtMoney}}</label>
                                </v-flex>
                                <a-text-field :disabled="!newState" label="Anotações para Fechamento"
                                              v-model="formData.notes" validate="required" xs12></a-text-field>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex md4 pa-0 xs12>
                    <v-flex xs12>
                        <v-slide-y-transition>
                            <v-card>
                                <v-card-title class="subheading">Recebimentos Registrados</v-card-title>
                                <v-card-text>
                                    <a-data-grid :columns="paymentCols" :data="payments"
                                                 :options="paymentOptions"></a-data-grid>
                                </v-card-text>
                            </v-card>
                        </v-slide-y-transition>
                    </v-flex>

                    <v-flex xs12>
                        <v-slide-y-transition>
                            <v-card>
                                <v-card-title class="subheading">Pagamentos / Retiradas</v-card-title>
                                <v-card-text>
                                    <a-data-grid :columns="withdrawsCols" :data="withdraws"
                                                 :options="paymentOptions"></a-data-grid>
                                </v-card-text>
                            </v-card>
                        </v-slide-y-transition>
                    </v-flex>
                </v-flex>

                <v-flex md8 xs12>
                    <v-slide-y-transition>
                        <v-card>
                            <v-card-title class="subheading">Trocas Registradas</v-card-title>
                            <v-card-text>
                                <a-data-grid :columns="exchangeCols" :data="exchanges" :height="610"
                                             :options="exchangeOptions"></a-data-grid>
                            </v-card-text>
                        </v-card>
                    </v-slide-y-transition>
                </v-flex>


            </v-layout>

        </crud-form>

    </div>
</template>

<script>
   import numeral from 'numeral';
   import CrudFormClass from "@consigmais-team/vue-common/layout/crudPage/crudFormClass";

   export default CrudFormClass.extend({

      name: 'CloseCashierForm',

      data() {
         return {
            title: 'Caixa Fechado',
            formName: 'closeCashierForm',
            emptyData: null,

            selectedUser: null,
            selectedUserCompany: null,

            cashierEndBalance: 0,

            formData: {
               id: null,
               companyId: this.$store.state.company.selectedStore,
               userId: this.$store.state.company.user.id,
               done_at: null,
               notes: null,
               origin: 'E',
               balance: 0,
               difference: 0,
               closed_at: null,
               details: {checks: 0, fees: 0, netTotal: 0, paymts: 0}
            },

            summary: null,
            exchanges: null,
            payments: null,
            withdraws: null,

            summaryCols: [
               {
                  dataField: 'journalName',
                  caption: 'Tipo de Transação',
                  minWidth: 170
               },
               {
                  dataField: 'signedTotal',
                  caption: 'Total',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  minWidth: 90
               }
            ],

            summaryOptions: {
               selection: {
                  mode: 'none'
               },
               summary: {
                  texts: {sum: '{0}', count: '{0}'},
                  totalItems: [
                     {
                        column: 'signedTotal',
                        valueFormat: {type: 'currency', precision: 2},
                        summaryType: 'sum'
                     }
                  ]
               }
            },

            exchangeCols: [
               {
                  dataField: 'clientName',
                  caption: 'Cliente',
                  minWidth: 110
               },
               {
                  dataField: 'employerName',
                  caption: 'Empresa',
                  minWidth: 110
               },
               {
                  dataField: 'check_amount',
                  caption: 'Cheque',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  width: 105
               },
               {
                  dataField: 'fee_total',
                  caption: 'Taxa',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  width: 90
               },
               {
                  dataField: 'fee_percent',
                  caption: 'Taxa %',
                  dataType: 'number',
                  format: {type: 'percent', precision: 1},
                  width: 80
               },
               {
                  dataField: 'net_total',
                  caption: 'Liquido',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  width: 105
               }
            ],

            exchangeOptions: {
               selection: {
                  mode: 'none'
               },
               summary: {
                  texts: {sum: '', count: '{0}'},
                  totalItems: [
                     {
                        column: 'check_amount',
                        valueFormat: {type: 'currency', precision: 2},
                        summaryType: 'sum'
                     },
                     {
                        column: 'fee_total',
                        valueFormat: {type: 'currency', precision: 2},
                        summaryType: 'sum'
                     },
                     {
                        column: 'net_total',
                        valueFormat: {type: 'currency', precision: 2},
                        summaryType: 'sum'
                     }
                  ]
               }
            },

            paymentCols: [
               {
                  dataField: 'clientName',
                  caption: 'Cliente',
                  minWidth: 115
               },
               {
                  dataField: 'mobile_number',
                  caption: 'Fone',
                  minWidth: 90
               },
               {
                  dataField: 'amount',
                  caption: 'Valor',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  width: 90
               },
               {
                  dataField: 'notes',
                  caption: 'Observações',
                  minWidth: 200
               }
            ],

            paymentOptions: {
               selection: {
                  mode: 'none'
               },
               summary: {
                  texts: {sum: '', count: '{0}'},
                  totalItems: [
                     {
                        column: 'amount',
                        valueFormat: {type: 'currency', precision: 2},
                        summaryType: 'sum'
                     }
                  ]
               }
            },

            withdrawsCols: [
               {
                  dataField: 'notes',
                  caption: 'Descrição',
                  minWidth: 110
               },
               {
                  dataField: 'amount',
                  caption: 'Valor Pago',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  width: 100
               }
            ]

         }

      },

      watch: {
         'formData.balance': function (val) {
            if (this.newState)
               this.formData.difference = numeral(val).value() - this.cashierEndBalance;
         },

         'pageFilters': {
            immediate: true,
            handler: function (val) {
               let self = this;
               this.formData.userId = val.userId;
               this.formData.companyId = val.storeId;

               this.pageFilterLabels.forEach((l) => {
                  if (l.field === 'userId') self.selectedUser = l.text;
                  if (l.field === 'storeId') self.selectedUserCompany = l.text;
               });

               if (val && Object.keys(val).length)
                  this.loadData(val);
            }
         }
      },


      computed: {
         storeId() {
            return this.formData.companyId || this.$store.state.company.selectedStore;
         },

         storeName() {
            return (this.selectedUserCompany) ? this.selectedUserCompany : this.$store.state.company.selectedStoreName;
         },

         userName() {
            return (this.selectedUser) ? this.selectedUser : this.$store.state.company.user.name;
         }


      },

      methods: {
         print() {
            this.$api.dataService.getData('closeReport/print', {id: this.formKey, origin: 'E'})
               .then( data => {
                  let win = window.open('', '_blank');
                  pdfMake.createPdf(data).print({}, win);
               });
         },
         onParamsChange(value) {
            if (!value && this.emptyData)
               this.assignData(JSON.parse(this.emptyData));
         },

         beforeSave() {
            let skipSave = false;
            // console.log(this.formData.selectedCheck);

            if (this.formData.selectedCheck && this.formData.selectedCheck.length > 1) {
               skipSave = true;
               this.$notifyUser({
                  type: 'error',
                  message: 'Selecione apenas um cheque!'
               });
            }

            /*if (!this.exchanges && !this.payments) {
               skipSave = true;
               this.$notifyUser({
                  type: 'info',
                  message: 'Não há transações para fechar!'
               });
            }*/

            return skipSave;

         },

         saveConfirmation() {
            return new Promise((resolve, reject) => {
               this.$msg.confirm({
                  title: 'Fechar Caixa',
                  message: 'Confirma este fechamento de caixa?',
                  actions: ['Sim', 'Não'],
                  defaultAction: 0
               }).then((action) => (action === 0) ? resolve(true) : reject(false));
            });
         },

         afterSave(data) {
            if (data) {
               let win = window.open('', '_blank');
               pdfMake.createPdf(data).print({}, win);
            }
            this.loadData(this.pageFilters);
            this.formData.cashierEndBalance = 0;
            this.formData.difference = 0;
         },

         afterDataLoad(data) {
            // this.log('AfterDataLoad');
            this.formData.closed_at = `#${data.id} - Fechado em ` + this.$moment(data.closed_at).format('MM/DD/YYYY h:mm a');
            this.selectedUser = data.name;
            this.selectedUserCompany = data.storeName;
            this.loadData(null, {closeReportId: data.id});
         },

         loadData(filters, closedReport) {
            // this.log('LoadData:', filters, closedReport);
            this.$api.dataService.getData('exchangeJournal/cashierReport', closedReport || filters)
               .then((data) => {
                  if (data) {
                     this.summary = data.summary;
                     this.exchanges = data.exchanges;
                     this.payments = data.payments;
                     this.withdraws = data.withdraws;


                     if (!closedReport) {
                        let details = {checks: 0, fees: 0, netTotal: 0, paymts: 0};
                        this.cashierEndBalance = 0;

                        if (this.summary && this.summary.length) {
                           this.summary.forEach(i => this.cashierEndBalance += +i.signedTotal);
                        }

                        if (this.exchanges && this.exchanges.length) {
                           this.exchanges.forEach(i => {
                              details.checks += +i.check_amount;
                              details.fees += +i.fee_total;
                              details.netTotal += +i.net_total;
                           });
                        }

                        if (this.payments && this.payments.length) {
                           this.payments.forEach(i => {
                              details.paymts += +i.amount;
                           });
                        }

                        this.formData.details = details;

                     }

                  }
               })

         }

      },


      created() {
         if (!this.hasPageFilters) {
            this.createPageFilters([
               {field: 'storeId'},
               {field: 'userId'}
            ]);

            //Defining default filters
         }

         console.log('Created');

         this.setPageFilter('storeId', this.$store.state.company.selectedStore, this.$store.state.company.selectedStoreName);
         this.setPageFilter('userId', this.$store.state.company.user.id, this.$store.state.company.user.name);


      },

      mounted() {
         this.emptyData = this.validFormData();
      }


   })

</script>

<style scoped>


</style>








// WEBPACK FOOTER //
// src/pages/CloseCashier.vue